import mapboxgl from "mapbox-gl";

function renderMap(latitude, longitude) {
	mapboxgl.accessToken =
		"pk.eyJ1IjoiZW1pbGtqYW5kZXJzc29uIiwiYSI6ImNsaXZleTAyNzAxc2oza3FsZWhzazVxMHYifQ.m_Rv4YYKdB0uR22jKdJ5MQ";
	var map = new mapboxgl.Map({
		container: "map",
		style: "mapbox://styles/mapbox/streets-v11",
		center: [longitude, latitude],
		zoom: 12,
	});

	map.on("load", function () {
		map.addControl(new mapboxgl.NavigationControl());
		map.addControl(new mapboxgl.FullscreenControl());

		// Add a marker at the provided latitude and longitude
		new mapboxgl.Marker().setLngLat([longitude, latitude]).addTo(map);
	});
}

export default renderMap;
